import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getProductPricingFromBooking} from '../../utils/getProductPricingFrom'

type CostFromBookingProps = {
  product: Ventrata.Product
  currency: Basic.Currency
}

export const CostFromPerBooking = ({product, currency}: CostFromBookingProps) => {
  const amount = getProductPricingFromBooking(product, currency)

  return (
    <div className="font-bold text-[18px]">{formatMoney(amount, currency, {minimumFractionDigits: 0})} per booking</div>
  )
}
